import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Slide } from 'react-slideshow-image'
import { Breadcrumb, Form, InputNumber, Result, Select } from 'antd'
import { ShoppingCartOutlined, DownloadOutlined } from '@ant-design/icons'
import 'react-slideshow-image/dist/styles.css'

import { obtainInventoryEquip } from 'src/api/graphql'

import { useCart } from 'src/shared/hooks'

import { QButton, QLoading } from 'src/shared/components'

import Transforms from 'src/shared/helpers/transforms'

import { CardStyled, ProductStyled } from './styles'

const ProductDetails = () => {
  const [inventory, setInventory] = useState<any>()
  const [invImages, setInvImages] = useState<string[]>()
  const [options, setOptions] = useState<any>()
  const [quantity, setQuantity] = useState<number | null>(1)
  const { sku } = useParams()
  const navigate = useNavigate()

  const { addProductToCart } = useCart()

  const { data, loading, error } = obtainInventoryEquip({ skuEquip: sku })

  const handleAdd = () => {
    const product = { ...Transforms.inventory2product(inventory), qty: quantity ?? 1 }
    addProductToCart(product)
    setQuantity(1)
  }

  useEffect(() => {
    if (data) {
      const isProductActive = data?.obtainInventoryEquip?.isActive
      const hasProductStore = data?.obtainInventoryEquip?.brandEntity?.hasStore
      if (!isProductActive) {
        if (hasProductStore) {
          navigate(`/providers/${data?.obtainInventoryEquip?.brand}`)
        } else {
          navigate('/products')
        }
        return
      }
      setInventory(data?.obtainInventoryEquip)
      setInvImages(Transforms.inv2productImages(data?.obtainInventoryEquip))
      setOptions(
        data?.obtainInventoryEquip?.variants.map((inv: any) => ({
          key: inv.key,
          label: inv.variant || inv.product,
          value: inv.skuEquip,
        }))
      )
    }
  }, [data])

  const handleError = ({ currentTarget }: React.SyntheticEvent<HTMLImageElement, Event>) => {
    currentTarget.onerror = null
    currentTarget.src = '/images/no-image.png'
    currentTarget.className = 'fallback'
  }

  if (error) {
    return (
      <Result
        status="404"
        title="Producto no encontrado"
        extra={
          <QButton type="primary" href="/products">
            Volver a productos
          </QButton>
        }
      />
    )
  }

  return (
    <QLoading loading={loading}>
      <ProductStyled>
        <Breadcrumb
          className="breadcrumb"
          items={[
            { href: '/', title: 'Inicio' },
            {
              href: inventory?.brandEntity?.hasStore
                ? `/providers/${inventory?.brand}`
                : `/products?brands=${inventory?.brand}`,
              title: 'Tienda',
            },
            { title: inventory?.product },
          ]}
        />
        <CardStyled>
          <div className="card-container">
            <div className="img-container">
              {invImages && (
                <Slide autoplay={false} transitionDuration={300}>
                  {invImages?.map((img) => (
                    <img key={img} src={img} alt={inventory?.product} onError={handleError} />
                  ))}
                </Slide>
              )}
            </div>
            <div className="detail-container">
              <span>
                <span style={{ fontSize: 16 }}>Marca:</span>{' '}
                <a
                  href={
                    inventory?.brandEntity?.hasStore
                      ? `/providers/${inventory?.brand}`
                      : `/products?brands=${inventory?.brand}`
                  }
                  style={{ fontSize: 16, color: '#030852', fontWeight: 600 }}
                >
                  {inventory?.brand}
                </a>
              </span>
              <h2 className="title">{inventory?.product}</h2>
              {/* <p className="subtitle">Descripción:</p> */}
              <ul className="description-list">
                <li>{inventory?.description}</li>
              </ul>
              <div className="divider" />
              <Form layout="vertical">
                <div className="form-group">
                  {inventory?.variant?.length || inventory?.variants?.length ? (
                    <Form.Item label="Variante:" style={{ minWidth: 50 }}>
                      <Select
                        value={inventory?.variant || inventory?.product}
                        options={options}
                        onSelect={(skuEquip) => navigate(`/products/${skuEquip}`)}
                      />
                    </Form.Item>
                  ) : null}
                  <Form.Item label="Cantidad:">
                    <InputNumber
                      required
                      min={1}
                      value={quantity}
                      onChange={(v) => setQuantity(v)}
                    />
                  </Form.Item>
                </div>
              </Form>
              <div className="actions">
                <QButton
                  equip="secondary"
                  size="large"
                  icon={<ShoppingCartOutlined />}
                  onClick={handleAdd}
                >
                  Agregar a Cotizar
                </QButton>
                {inventory?.techsheetUrl ? (
                  <QButton
                    size="large"
                    icon={<DownloadOutlined />}
                    href={inventory?.techsheetUrl}
                    target="_blank"
                  >
                    Ficha Técnica
                  </QButton>
                ) : null}
              </div>
            </div>
          </div>
        </CardStyled>
      </ProductStyled>
    </QLoading>
  )
}
export default ProductDetails
